export default (state = [], action) => {
    switch (action.type) {
        case 'WHEEL_POSITION':
            return action.payload;
        default:
            return state;
    }
};
